import { Tooltip } from '@mui/material';
import React from 'react';

export interface coloredSectionProps {
  toolTipText: string;
  widthInPrec: string;
  color: string;
  isRounded: boolean;
  isFirst?: boolean;
  isLast?: boolean;
}

export const ColoredSection: React.FC<coloredSectionProps> = ({
  color,
  isRounded,
  toolTipText,
  widthInPrec,
  isFirst = false,
  isLast = false,
}) => {
  return (
    <Tooltip title={toolTipText}>
      <div
        style={{ width: `${widthInPrec}%`, background: color }}
        className={``
          .concat(isRounded ? 'rounded-r-full' : '')
          .concat(isFirst && !isRounded ? 'border-l' : '')
          .concat(isLast && !isRounded ? 'border-r' : '')}
      ></div>
    </Tooltip>
  );
};
